export default "__VITE_PUBLIC_ASSET__779201ab__"